import { render, staticRenderFns } from "./FormAccordion.vue?vue&type=template&id=794b8d04&scoped=true&lang=pug&"
import script from "./FormAccordion.vue?vue&type=script&lang=js&"
export * from "./FormAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FormAccordion.vue?vue&type=style&index=0&id=794b8d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b8d04",
  null
  
)

export default component.exports